
const Request = require('app/graphql/Request');

class MultiQuery extends Request {

	defaultOptions(){
		var self = this;
		var options = {
            'queries': [],//list of app/graphql/Query
		};
		return Object.assign(super.defaultOptions(),options);
	}

    initialize() {

    	return this;
    }


    buildData(){
        let data = this.settings.data;
        data.append('query',this.buildQuery());
        return data;
    }

    buildQuery(){

        let query = '';
        for(var i in this.settings.queries){
            let queryObject = this.settings.queries[i];
            let currentQuery = queryObject.buildQuery(true);
            query += `
                ${currentQuery}
            `;
        }

        return `{
            ${query}
        }
        `;
    }

    success(xhr){
        if( this.settings.success && xhr.data){
            return this.settings.success(xhr.data);
        }
    }
    
    error(message, xhr){
        return super.error(message,xhr);
    }



}

module.exports = MultiQuery;
